<template>
  <div class="content-width py-4">
    <b-button
      squared
      variant="manage_main"
      type="button"
      v-b-modal.modalVendorModal
      >新增廠商</b-button
    >
    <div class="pt-4">
      <b-alert show variant="light">
        <span class="text-success">*綠色</span>：有效租期 、
        <span class="text-danger">*紅色</span>：無效租期
      </b-alert>
      <b-table
        v-if="!isMobile"
        responsive
        striped
        hover
        bordered
        head-variant="light"
        :items="sortVendor"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
        empty-text="目前尚無資料"
        empty-filtered-text="沒有找到符合的廠商"
        show-empty
      >
        <template v-slot:head()="scope">
          <div class="text-nowrap">
            {{ scope.label }}
          </div>
        </template>
        <template v-slot:emptyfiltered="{ emptyFilteredText }">
          <div class="text-center">{{ emptyFilteredText }}</div>
        </template>
        <template v-slot:cell(zone)="data">
          {{ getZone(data.item.zone) }}
        </template>
        <template v-slot:cell(account_status)="data">
          <div class="status-switch">
            <input
              type="checkbox"
              :id="'switch-' + data.index"
              v-model="data.item.account_status"
              @click="
                changeAccount_status('switch-' + data.index, data.item.id)
              "
            />
            <label :for="'switch-' + data.index"></label>
          </div>
        </template>
        <template v-slot:cell(sease_term)="data">
          <div
            :class="
              compareDates(data.item.started_date, data.item.expired_date)
                ? 'text-success'
                : 'text-danger'
            "
          >
            <span class="text-nowrap">
              {{
                (stringDate(data.item.started_date, "yyyy-MM-dd") || "") + " ~ "
              }}</span
            >
            <span class="text-nowrap">
              {{ stringDate(data.item.expired_date, "yyyy-MM-dd") || "" }}</span
            >
          </div>
        </template>
        <template v-slot:cell(active)="data">
          <b-dropdown
            right
            no-caret
            variant="link"
            boundary="viewport"
            class="btn-only-icon"
          >
            <template v-slot:button-content>
              <b-icon icon="three-dots-vertical" variant="dark"></b-icon>
            </template>
            <b-dropdown-item href="#" @click="edit(data.item.id)"
              >編輯</b-dropdown-item
            >
          </b-dropdown>
        </template>
      </b-table>

      <b-table
        v-else
        striped
        bordered
        head-variant="light"
        :items="sortVendor"
        :fields="fields_mobile"
        :per-page="perPage"
        :current-page="currentPage"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
        empty-text="目前尚無資料"
        empty-filtered-text="沒有找到符合的廠商"
        show-empty
      >
        <template v-slot:head()="scope">
          <div class="text-nowrap">
            {{ scope.label }}
          </div>
        </template>
        <template v-slot:emptyfiltered="{ emptyFilteredText }">
          <div class="text-center">{{ emptyFilteredText }}</div>
        </template>
        <template v-slot:cell(show_details)="row">
          <div class="btn-only-icon">
            <b-button
              @click="row.toggleDetails"
              class="btn-link border-0"
              variant="outline-light"
              size="sm"
            >
              <b-icon
                :icon="row.detailsShowing ? 'chevron-down' : 'chevron-right'"
                variant="dark"
              ></b-icon>
            </b-button>
          </div>
        </template>
        <template v-slot:cell(account_status)="data">
          <div class="status-switch">
            <input
              type="checkbox"
              :id="'switch-' + data.index"
              v-model="data.item.account_status"
              @click="
                changeAccount_status('switch-' + data.index, data.item.id)
              "
            />
            <label :for="'switch-' + data.index"></label>
          </div>
        </template>
        <template v-slot:cell(active)="data">
          <b-dropdown
            right
            no-caret
            variant="link"
            boundary="viewport"
            class="btn-only-icon"
          >
            <template v-slot:button-content>
              <b-icon icon="three-dots-vertical" variant="dark"></b-icon>
            </template>
            <b-dropdown-item href="#" @click="edit(data.item.id)"
              >編輯</b-dropdown-item
            >
          </b-dropdown>
        </template>
        <template v-slot:row-details="row">
          <b-card>
            <b-row class="mb-3">
              <b-col>
                <img
                  :src="getCompleteImageUrl(row.item.image_link)"
                  alt="廠商圖片"
                  style="width:100%"
                />
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col sm="3"><b>負責人</b></b-col>
              <b-col>{{ row.item.principal }}</b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col sm="3"><b>手機</b></b-col>
              <b-col>{{ row.item.telephone }}</b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col sm="3"><b>統一編號</b></b-col>
              <b-col>{{ row.item.tax_id }}</b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col sm="3"><b>分區</b></b-col>
              <b-col>{{ getZone(row.item.zone) }}</b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col sm="3"><b>地址</b></b-col>
              <b-col
                >{{ getPostcode(row.item.town_id) }}{{ row.item.city_name
                }}{{ row.item.town_name }}{{ row.item.address }}</b-col
              >
            </b-row>
            <b-row class="mb-3">
              <b-col sm="3"><b>簡介</b></b-col>
              <b-col v-html="row.item.description"></b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col sm="3"><b>租期</b></b-col>
              <b-col
                :class="
                  compareDates(row.item.started_date, row.item.expired_date)
                    ? 'text-success'
                    : 'text-danger'
                "
              >
                {{
                  (stringDate(row.item.started_date, "yyyy-MM-dd") || "") +
                    " ~ " +
                    (stringDate(row.item.expired_date, "yyyy-MM-dd") || "")
                }}
              </b-col>
            </b-row>
            <b-row class="">
              <b-col class="text-center">
                <b-button
                  size="sm"
                  squared
                  variant="manage_main"
                  @click="row.toggleDetails"
                  >收起詳細資訊</b-button
                >
              </b-col>
            </b-row>
          </b-card>
        </template>
      </b-table>

      <div class="row align-items-center" v-if="totalRows">
        <div class="col-sm col-12 text-right text-sm-left">
          顯示第 {{ currentPage == 1 ? 1 : perPage * (currentPage - 1) + 1 }} 至
          {{
            currentPage == 1
              ? totalRows > perPage
                ? perPage
                : totalRows
              : perPage * (currentPage - 1) + perPage > totalRows
              ? totalRows
              : perPage * (currentPage - 1) + perPage
          }}
          項結果，共 {{ totalRows }} 項
        </div>
        <div class="col-sm col-12">
          <b-pagination
            v-if="totalRows > perPage"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="right"
            first-number
            last-number
            class="mb-sm-0 mb-3 mt-sm-0 mt-3 manage_main"
          ></b-pagination>
        </div>
      </div>
    </div>
    <b-modal
      id="modalVendorModal"
      :title="modal_title"
      footer-class="d-flex justify-content-between"
      no-close-on-backdrop
      centered
      tall
      scrollable
      @ok="onSubmit"
      @show="showModal"
      @hidden="hiddenModal"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="名稱"
          label-for="vendorcompany_name"
          invalid-feedback="請填寫廠商名稱"
          :state="state.company_name"
          class="required"
        >
          <b-form-input
            id="vendorcompany_name"
            class="rounded-0"
            v-model="form.company_name"
            type="text"
            required
            placeholder="廠商名稱"
            :state="state.company_name"
            :readonly="isEdit"
          ></b-form-input>
        </b-form-group>
        <TWCityTown
          @childMethod="getTWCityTown"
          :state="state.TW_city_town"
          :group_class="'required'"
          :town_id="form.town_id"
          :address="form.address"
          :readonly="isEdit"
        ></TWCityTown>
        <b-form-group
          label="負責人姓名"
          label-for="vendorprincipal"
          invalid-feedback="請填寫廠商負責人姓名"
          :state="state.principal"
          class="required"
        >
          <b-form-input
            id="vendorprincipal"
            class="rounded-0"
            v-model="form.principal"
            type="text"
            required
            placeholder="廠商負責人"
            :state="state.principal"
            :readonly="isEdit"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="手機號碼"
          label-for="vendorTelephone"
          invalid-feedback="請填寫廠商負責人手機號碼"
          :state="state.telephone"
          class="required"
        >
          <b-form-input
            id="vendorTelephone"
            class="rounded-0"
            v-model="form.telephone"
            type="text"
            required
            placeholder="手機號碼"
            :state="state.telephone"
            :readonly="isEdit"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="統一編號" label-for="vendorTaxID">
          <b-form-input
            id="vendorTaxID"
            class="rounded-0"
            v-model="form.tax_id"
            type="text"
            placeholder="統一編號"
            :readonly="isEdit"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          class="required"
          label="廠商敘述"
          label-for="vendorDescription"
          invalid-feedback="請填寫廠商介紹"
          :state="state.description"
        >
          <b-form-textarea
            id="vendorDescription"
            class="rounded-0"
            v-model="form.description"
            type="text"
            placeholder="廠商介紹"
            :state="state.description"
            rows="5"
          ></b-form-textarea>
        </b-form-group>
        <ManageDateRangePicker
          @childMethod="getDateRangePicker"
          :state="state.sease_term"
          :group_class="'required'"
          :startDate="form.started_date"
          :endDate="form.expired_date"
          :future="true"
          startName="租期-起始日期"
          endName="租期-結束日期"
        ></ManageDateRangePicker>
        <ImagePreview
          @childMethod="getImageUrl"
          :state="state.image_link"
          :image="form.image_link"
          :token="token"
          :required="true"
        ></ImagePreview>
      </form>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button squared variant="outline-dark" type="button" @click="cancel()"
          >取消</b-button
        >
        <b-button squared variant="manage_main" type="submit" @click="ok()"
          >儲存</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import "@/assets/js/dateFormat.js";
import { Vendor } from "@/assets/api/manage.js";
import { getZone } from "@/assets/api.config.js";
import { Swal, Toast } from "@/plugins/sweetalert2.js";
import TWCityTown from "@/components/TWCityTown.vue";
import ImagePreview from "@/components/ImagePreview.vue";
import ManageDateRangePicker from "@/components/DateRangePicker.vue";

export default {
  name: "Vendor",
  props: ["search", "isMobile", "token"],
  components: { TWCityTown, ImagePreview, ManageDateRangePicker },
  data() {
    return {
      currentPage: 1,
      edit_id: null,
      fields: [
        {
          key: "company_name",
          label: "廠商名稱",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "zone",
          label: "廠商分區",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "principal",
          label: "負責人",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "telephone",
          label: "手機",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "sease_term",
          label: "租期",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "account_status",
          label: "狀態",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "active",
          label: "",
          tdClass: "align-middle",
          thStyle: "width:35px"
        }
      ],
      fields_mobile: [
        {
          key: "show_details",
          label: "",
          tdClass: "align-middle",
          thStyle: "width:35px"
        },
        {
          key: "company_name",
          label: "廠商名稱",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "account_status",
          label: "狀態",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "active",
          label: "",
          tdClass: "align-middle",
          thStyle: "width:35px"
        }
      ],
      filter: null,
      filterOn: ["company_name"],
      form: {
        company_name: "",
        zone: "",
        town_id: "",
        address: "",
        principal: "",
        tax_id: "",
        telephone: "",
        description: "",
        started_date: "",
        expired_date: "",
        image_link: ""
      },
      isEdit: false,
      isModalShow: false,
      items: null,
      modal_title: "新增廠商",
      perPage: 10,
      state: {
        company_name: null,
        TW_city_town: null,
        principal: null,
        telephone: null,
        description: null,
        sease_term: null,
        image_link: null
      },
      totalRows: null,
      complete_address: null,
      TW_city_town: null
    };
  },
  created() {
    this.perPage = process.env.VUE_APP_TABLE_ROW_LENGTH || 15;
    this.filter = this.search;
    this.getVendor();
    getZone()
      .then(res => {
        if (res.status <= 201) {
          this.TW_city_town = res.data;
        } else {
          Toast.fire({
            icon: "error",
            title: "地區資料讀取失敗",
            text: res.data.error
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  },
  watch: {
    form: {
      handler: function() {
        if (this.isModalShow && this.isEdit) {
          this.checkFormState();
        }
      },
      deep: true
    }
  },
  computed: {
    sortVendor() {
      if (!this.items) return;
      let items = this.items;
      items.sort(function(a, b) {
        return a.updated_at < b.updated_at ? 1 : -1;
      });
      return items;
    }
  },
  methods: {
    stringDate(date, format) {
      const newDate = new Date(date.toString().replace(/-/g, "/")).format(
        format
      );
      // 為了解決 ios 不支援日期"-"格式做計算，轉成"/"後，再轉出
      return newDate;
    },
    compareDates(start, expire) {
      const startDate = new Date(start);
      const expireDate = new Date(expire);
      const today = new Date();
      if (today < startDate || today > expireDate) {
        return false;
      }
      return true;
    },
    getVendor() {
      Vendor.get(this.token)
        .then(res => {
          if (res.status <= 201) {
            this.items = res.data;
            this.totalRows = this.items.length;
            console.log(this.items);
          } else {
            Toast.fire({
              icon: "error",
              title: "廠商資料讀取失敗",
              text: res.data.error
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    getPostcode(town_id) {
      let postcode = "";
      this.TW_city_town.forEach(city => {
        city.towns.forEach(item => {
          if (town_id === item.id) {
            postcode = item.postcode;
          }
        });
      });
      return postcode;
    },
    format(date, formatText) {
      // "yyyy-MM-dd"
      return new Date(date).format(formatText);
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getDateRangePicker(data) {
      this.form.started_date = data.startDate + " 00:00:00";
      this.form.expired_date = data.endDate + " 00:00:00";
    },
    getImageUrl(data) {
      this.form.image_link = data;
    },
    getCompleteImageUrl(url) {
      return (process.env.VUE_APP_API_BASE_URL || "") + url;
    },
    getTWCityTown(data) {
      this.form.town_id = data.town_id;
      this.form.address = data.address;
      this.form.zone = data.zone;
      this.complete_address = data.complete_address;
    },
    getZone(zone) {
      switch (zone) {
        case 1:
          return "北部";
        case 2:
          return "中部";
        case 3:
          return "南部";
        case 4:
          return "東部";
        case 5:
          return "離島";
      }
    },
    changeAccount_status(ele, id) {
      if (!document.getElementById(ele).checked) {
        Swal.fire({
          title: "更改為停用狀態",
          text: "確定要停用嗎？",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "取消",
          confirmButtonText: "停用"
        }).then(result => {
          if (result.value) {
            Vendor.status(id, { account_status: 0 }, this.token)
              .then(res => {
                if (res.status <= 201) {
                  Toast.fire({
                    icon: "success",
                    title: "修改成功"
                  });
                  // document.getElementById(ele).checked = false;
                  this.getVendor();
                } else {
                  Toast.fire({
                    icon: "error",
                    title: "修改失敗",
                    text: res.data.error
                  });
                  document.getElementById(ele).checked = true;
                }
              })
              .catch(error => {
                console.error(error);
              });
          } else {
            document.getElementById(ele).checked = true;
          }
        });
      } else {
        Swal.fire({
          title: "更改為啟用狀態",
          text: "確定要啟用嗎？",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "取消",
          confirmButtonText: "啟用"
        }).then(result => {
          if (result.value) {
            Vendor.status(id, { account_status: 1 }, this.token)
              .then(res => {
                if (res.status <= 201) {
                  Toast.fire({
                    icon: "success",
                    title: "修改成功"
                  });
                  // document.getElementById(ele).checked = true;
                  this.getVendor();
                } else {
                  Toast.fire({
                    icon: "error",
                    title: "修改失敗",
                    text: res.data.error
                  });
                  document.getElementById(ele).checked = false;
                }
              })
              .catch(error => {
                console.error(error);
              });
          } else {
            document.getElementById(ele).checked = false;
          }
        });
      }
    },
    resetForm() {
      this.modal_title = "新增廠商";
      this.isEdit = false;
      this.edit_id = null;

      this.state.company_name = null;
      this.state.TW_city_town = null;
      this.state.principal = null;
      this.state.telephone = null;
      this.state.description = null;
      this.state.sease_term = null;
      this.state.image_link = null;

      this.form.company_name = "";
      this.form.town_id = "";
      this.form.address = "";
      this.form.principal = "";
      this.form.tax_id = "";
      this.form.telephone = "";
      this.form.description = "";
      this.form.started_date = "";
      this.form.expired_date = "";
      this.form.image_link = "";
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.checkFormState();
      return valid;
    },
    checkFormState() {
      this.form.company_name
        ? (this.state.company_name = null)
        : (this.state.company_name = false);
      this.form.town_id && this.form.address
        ? (this.state.TW_city_town = null)
        : (this.state.TW_city_town = false);
      this.form.principal
        ? (this.state.principal = null)
        : (this.state.principal = false);
      this.form.telephone
        ? (this.state.telephone = null)
        : (this.state.telephone = false);
      this.form.description
        ? (this.state.description = null)
        : (this.state.description = false);
      this.form.started_date && this.form.expired_date
        ? (this.state.sease_term = null)
        : (this.state.sease_term = false);
      this.form.image_link
        ? (this.state.image_link = null)
        : (this.state.image_link = false);
    },
    edit(id) {
      this.resetForm();
      this.isEdit = true;
      this.edit_id = id;
      this.$root.$emit("bv::show::modal", "modalVendorModal", "#btnShow");
    },
    showModal() {
      this.isModalShow = true;
      if (this.isEdit) {
        this.modal_title = "編輯廠商";
        this.items.forEach(item => {
          if (this.edit_id === item.id) {
            this.form.company_name = item.company_name;
            this.form.town_id = item.town_id;
            this.form.address = item.address;
            this.form.principal = item.principal;
            this.form.tax_id = item.tax_id;
            this.form.telephone = item.telephone;
            this.form.description = item.description;
            this.form.started_date = item.started_date;
            this.form.expired_date = item.expired_date;
            this.form.image_link = item.image_link;
          }
        });
      } else {
        this.resetForm();
      }
    },
    hiddenModal() {
      this.isModalShow = false;
      this.resetForm();
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.handleSubmit();
    },
    handleSubmit() {
      if (!this.checkFormValidity()) {
        return;
      }
      for (const [key, value] of Object.entries(this.state)) {
        if (value === false) {
          console.log(key);
          return;
        }
      }
      if (this.isEdit) {
        Vendor.update(this.edit_id, this.form, this.token)
          .then(res => {
            if (res.status <= 201) {
              Toast.fire({
                icon: "success",
                title: "編輯成功"
              });
              this.$root.$emit(
                "bv::hide::modal",
                "modalVendorModal",
                "#btnShow"
              );
              this.getVendor();
            } else {
              Toast.fire({
                icon: "error",
                title: "編輯失敗",
                text: res.data.error
              });
            }
          })
          .catch(err => {
            console.error(err);
          });
      } else {
        Swal.fire({
          title: "再次確認",
          // width: 600,
          padding: "20px 0",
          html: `請確認以下內容是否正確？
          <hr>
          <div class="text-left">
            <div class="row mb-3">
              <div class="col-sm-3">
                <b>廠商名稱</b>
              </div>
              <div class="col">${this.form.company_name}</div>
            </div>
            <div class="row mb-3">
              <div class="col-sm-3">
                <b>地址</b>
              </div>
              <div class="col">${this.complete_address}</div>
            </div>
            <div class="row mb-3">
              <div class="col-sm-3">
                <b>負責人</b>
              </div>
              <div class="col">${this.form.principal}</div>
            </div>
            <div class="row mb-3">
              <div class="col-sm-3">
                <b>廠商簡介</b>
              </div>
              <div class="col">${this.form.description}</div>
            </div>
            <div class="row mb-3">
              <div class="col-sm-3">
                <b>圖片</b>
              </div>
              <div class="col"><img src="${this.getCompleteImageUrl(
                this.form.image_link
              )}" alt="" style="width:100%;"></div>
            </div>
            <div class="row mb-3">
              <div class="col-sm-3">
                <b>租期</b>
              </div>
              <div class="col">${this.form.started_date} ~ ${
            this.form.expired_date
          }</div>
            </div>
          </div>
          <hr>`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "取消",
          confirmButtonText: "確認"
        }).then(result => {
          if (result.value) {
            this.form.started_date = this.stringDate(
              this.form.started_date,
              "yyyy-MM-dd hh:mm:ss"
            );
            this.form.expired_date = this.stringDate(
              this.form.expired_date,
              "yyyy-MM-dd hh:mm:ss"
            );
            Vendor.create(this.form, this.token)
              .then(res => {
                if (res.status <= 201) {
                  Toast.fire({
                    icon: "success",
                    title: "新增成功"
                  });
                  this.$root.$emit(
                    "bv::hide::modal",
                    "modalVendorModal",
                    "#btnShow"
                  );
                  this.getVendor();
                } else {
                  Toast.fire({
                    icon: "error",
                    title: "新增失敗",
                    text: res.data.error
                  });
                }
              })
              .catch(err => {
                console.error(err);
              });
          }
        });
      }
    }
  }
};
</script>
